<template>
  <div>
    <div class="loader" v-if="loading"></div>

    <div v-else>
      <div class="justify-content-center insider-product-page">
        <div
          class="file-selection-bar with-report-date"
          style="clear: left"
          v-bind:class="getSelectionBarClass"
        >
          <div class="report-title">
            <form class="noFlex" v-on:change="selectReport(selected)">
              <label for="report-date" class="visually-hidden">
                Select a Report
              </label>
              <select name="report-date" id="report-date" v-model="selected">
                <option value="">Select a Report</option>
                <template v-for="report in reports" :key="report.id">
                  <option :value="report.id">
                    {{ momentFormat(report.issue, 'MMMM YYYY') }}
                    <span
                      v-if="
                        report.name &&
                        report.name !== '' &&
                        !template.slug.includes('at-a-glance')
                      "
                    >
                      - {{ report.name }}
                    </span>
                  </option>
                </template>
              </select>
            </form>
          </div>
          <div v-if="from_tr" class="tr-report-component">
            <div
              class="tr-report-component__icon"
              :class="hasNotifications ? 'active' : 'inactive'"
              @click="toggleNotification()"
            >
              <BaseTooltip
                :fromTrendsReport="true"
                placement="top"
                xAlign="center"
                yAlign="top"
                contentWidth="fit-content"
                :fromArticle="true"
                class="tr-report-component__tooltip"
                tooltipColor="white"
              >
                <template #display>
                  <span
                    class="icon-notification"
                    :class="hasNotifications ? 'active' : 'inactive'"
                  ></span>
                </template>
                <template #tooltip>
                  <p>
                    {{
                      hasNotifications
                        ? 'Turn Off Notifications'
                        : 'Receive Notifications'
                    }}
                  </p>
                </template>
              </BaseTooltip>
            </div>
            <div
              class="tr-report-component__icon"
              :class="isFavorite ? 'active' : 'inactive'"
              @click="toggleFavorite()"
            >
              <BaseTooltip
                :fromTrendsReport="true"
                placement="top"
                xAlign="center"
                yAlign="top"
                contentWidth="fit-content"
                :fromArticle="true"
                class="tr-report-component__tooltip"
                tooltipColor="white"
              >
                <template #display>
                  <span
                    class="icon-star"
                    :class="isFavorite ? 'active' : 'inactive'"
                  ></span>
                </template>
                <template #tooltip>
                  <p>
                    {{
                      isFavorite ? 'Remove from Favorites' : 'Add to Favorites'
                    }}
                  </p>
                </template>
              </BaseTooltip>
            </div>
            <div
              v-if="report.downloads.pdf || report.cwa_data"
              class="tr-report-component__icon-old"
              @mouseover="pdfHover = true"
              @mouseleave="pdfHover = false"
            >
              <a
                class="tr-report-component__tooltip"
                :href="'/storage/' + report.downloads.pdf"
                download
                @click="buildPdf()"
              >
                <img
                  :src="
                    pdfHover
                      ? '/images/icons/icon-pdf.svg'
                      : '/images/icons/icon-pdf-new.svg'
                  "
                  alt="File"
                />
              </a>
            </div>
            <div
              class="tr-report-component__icon-old"
              v-if="report.data_file"
              @mouseover="xlsHover = true"
              @mouseleave="xlsHover = false"
            >
              <a
                class="tr-report-component__tooltip"
                :href="'/storage/' + report.data_file"
              >
                <img
                  :src="
                    xlsHover
                      ? '/images/icons/icon-xls.svg'
                      : '/images/icons/icon-xls-new.svg'
                  "
                  alt="File"
                />
              </a>
            </div>
          </div>
          <div class="report-data-file" v-if="report.data_file && !from_tr">
            <span>Data File</span>
            <a :href="'/storage/' + report.data_file" v-if="report.data_file">
              <img :src="'/images/icons/icon-xls.svg'" alt="File" />
            </a>
          </div>
          <div class="report-files" v-if="!from_tr">
            <span>Report</span>
            <a
              :href="'/storage/' + report.downloads.doc"
              v-if="report.downloads.doc"
            >
              <img :src="'/images/icons/icon-doc.svg'" alt="File" />
            </a>
            <a
              :href="'/storage/' + report.downloads.xls"
              v-if="report.downloads.xls"
            >
              <img :src="'/images/icons/icon-xls.svg'" alt="File" />
            </a>
            <a
              :href="'/storage/' + report.downloads.pdf"
              v-if="report.downloads.pdf"
              download
            >
              <img :src="'/images/icons/icon-pdf.svg'" alt="File" />
            </a>
          </div>
        </div>
        <div class="row" :class="doscodeDefinition ? 'split-flex' : ''">
          <div class="col">
            <p
              class="small px-1 text-medium-left text-small-center report-upload-date-insider"
            >
              Published {{ report.update_date }}
            </p>
          </div>
          <div class="tr-custom-col-l">
            <p
              class="small px-1 text-medium-right text-small-center report-upload-date-insider"
            >
              {{ doscodeDefinition }}
            </p>
          </div>
          <div v-if="from_tr && doscodeDefinition" class="tr-custom-col-r">
            <BaseTooltip
              :fromTrendsReport="true"
              placement="top"
              xAlign="center"
              yAlign="top"
              contentWidth="medium"appUrl
              arrow
              class="tr-report-component__tooltip tr-report-component__tooltip--tr-info"
              tooltipColor="white"
              round
            >
              <template #display>
                <IconInformationCircle color="grey" width="18" height="18" />
              </template>
              <template #tooltip>
                <p>{{ report.cwa_data.DOSCodeDefinition }}</p>
              </template>
            </BaseTooltip>
          </div>
        </div>
      </div>

      <template v-if="report.cwa_data">
        <component
          v-bind:is="currentHtmlComponent"
          v-bind:cwaData="report.cwa_data"
          v-bind:fromTr="from_tr"
          v-bind:report="updatedReport"
          v-bind:imagespath="appUrl"
        ></component>
      </template>

      <template v-else-if="view_type === 'html'">
        <component
          :key="report.imagespath"
          v-bind:is="currentHtmlComponent"
          v-bind:content="report.json_content"
          v-bind:imagespath="`${appUrl}/storage/${report.imagespath}/`"
          v-bind:issue="report.issue"
          v-bind:fromTr="from_tr"
        ></component>
      </template>

      <div v-else-if="view_type === 'pdf'">
        <template v-if="!safarimobile">
          <div class="iframeEmbed insiderIframe--wrapper" id="google">
            <iframe
              class="insiderIframe"
              :src="'/storage/' + report.downloads.pdf"
            ></iframe>
          </div>
        </template>
        <template v-else>
          <div class="iframeEmbed insiderIframe--wrapper" id="google">
            <iframe
              :src="
                'https://docs.google.com/viewer?url=' +
                appUrl +
                '/storage/' +
                report.downloads.pdf +
                '&embedded=true'
              "
              style="width: 100%; height: 100%"
              frameborder="0"
            ></iframe>
          </div>
        </template>
      </div>

      <div v-if="carouselReports.length && isInsiderProduct">
        <div class="insider-product-page__carousel-title">
          <h2 clas="insider-product-page__title">
            Check Out Past Editions You May Have Missed
          </h2>
        </div>
        <CarouselContainer>
          <InsiderCarouselReportCard
            v-for="report in carouselReports"
            :key="`more-product-${report.id}`"
            :report="report"
            :image="image"
            @report-selected="handleReportSelected(report)"
          />
        </CarouselContainer>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  // Insider XML Components
  import InsiderAdvisorHtmlComponent from '../insider/AdvisorHTMLComponent.vue';
  import InsiderLeadingIndicatorsListComponent from '../insider/LeadingIndicatorsListComponent.vue';
  import InsiderLeadingIndicatorsComponent from '../insider/LeadingIndicators.vue';
  import InsiderThreeYearOutlookComponent from '../insider/ThreeYearOutlook.vue';
  import InsiderAdvisorAppHtmlComponent from '../insider/AdvisorAppHTMLComponent.vue';

  // TrendsReport XML Components
  import IndicatorTypeA from '../trendsreport/templates/IndicatorTypeA.vue';
  import IndicatorTypeB from '../trendsreport/templates/IndicatorTypeB.vue';
  import AtAGlance from '../trendsreport/templates/AtAGlance.vue';
  import Trends10 from '../trendsreport/templates/Trends10.vue';
  import LeadingIndicator from '../trendsreport/templates/LeadingIndicator.vue';
  import EconomicOutlook from '../trendsreport/templates/EconomicOutlook.vue';
  import ExecutiveSummary from '../trendsreport/templates/ExecutiveSummary.vue';
  import IndicatorTypes from '../trendsreport/templates/IndicatorTypes.vue';

  import IndicatorTypeATemplate from '../trendsreport/html/IndicatorTypeATemplate.vue';
  import IndicatorTypeBTemplate from '../trendsreport/html/IndicatorTypeBTemplate.vue';
  import AtAGlanceTemplate from '../trendsreport/html/AtAGlanceTemplate.vue';
  import Trends10Template from '../trendsreport/html/Trends10Template.vue';
  import LeadingIndicatorTemplate from '../trendsreport/html/LeadingIndicatorTemplate.vue';
  import EconomicOutlookTemplate from '../trendsreport/html/EconomicOutlookTemplate.vue';
  import ExecutiveSummaryTemplate from '../trendsreport/html/ExecutiveSummaryTemplate.vue';
  import GlobalAtAGlanceTemplate from '../trendsreport/html/GlobalAtAGlanceTemplate.vue';

  import CarouselContainer from '~/components/carousel/CarouselContainer.vue';
  import InsiderCarouselReportCard from '~/components/insider/InsiderCarouselReportCard.vue';
  import BaseTooltip from '~/components/base/BaseTooltip.vue';
  import AtAGlanceLegend from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceLegend.vue';
  import IconInformationCircle from '~/components/icon/IconInformation.vue';
  import { useAAGStore } from '~/stores/aag';

  export default {
    props: {
      report_to_view: {
        type: String,
        required: false,
      },
      template: {
        type: Object,
        required: false,
      },
      appUrl: {
        type: String,
        required: false,
      },
      from_tr: {
        type: Boolean,
        default: false,
      },
      sanitized_report: {
        type: Object,
        required: false,
      },
      filename: {
        type: String,
        default: 'trendsreport',
      },
      preselected_tr_id: {
        type: [Number, String],
        required: false,
      },
    },
    components: {
      InsiderAdvisorHtmlComponent,
      InsiderLeadingIndicatorsComponent,
      InsiderThreeYearOutlookComponent,
      InsiderAdvisorAppHtmlComponent,
      InsiderLeadingIndicatorsListComponent,
      'tr-indicator-type-a-component': IndicatorTypeA,
      'tr-indicator-type-b-component': IndicatorTypeB,
      'tr-at-a-glance-component': AtAGlance,
      'tr-global-at-a-glance-component': AtAGlance,
      'tr-trends-10-component': Trends10,
      'tr-leading-indicator-component': LeadingIndicator,
      'tr-economic-outlook-component': EconomicOutlook,
      'tr-executive-summary-component': ExecutiveSummary,
      'tr-indicator-types-component': IndicatorTypes,
      IndicatorTypeATemplate,
      IndicatorTypeBTemplate,
      AtAGlanceTemplate,
      Trends10Template,
      LeadingIndicatorTemplate,
      EconomicOutlookTemplate,
      ExecutiveSummaryTemplate,
      CarouselContainer,
      InsiderCarouselReportCard,
      BaseTooltip,
      AtAGlanceLegend,
      GlobalAtAGlanceTemplate,
      IconInformationCircle,
    },
    data: function () {
      return {
        loading: true,
        reports: [],
        selected: '', //make this the most recent report
        report: {
          name: '',
          data_file: '',
          json_content: '',
          imagespath: '',
          issue: '',
          downloads: {
            doc: '',
            xls: '',
            pdf: '',
          },
          iframe: '',
          update_date: '',
          cwa_data: null,
        },
        view_type: '',
        safarimobile:
          navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
          navigator.userAgent.match(/AppleWebKit/),
        image: '',
        isInsiderProduct: false,
        carouselReports: [],
        tr_cwa_mapping: {
          'tr-indicator-type-a': 'IndicatorTypeATemplate',
          'tr-indicator-type-b': 'IndicatorTypeBTemplate',
          'tr-at-a-glance': 'AtAGlanceTemplate',
          'tr-trends-10': 'Trends10Template',
          'tr-leading-indicator': 'LeadingIndicatorTemplate',
          'tr-economic-outlook': '', // todo - waiting on business
          'tr-executive-summary': 'ExecutiveSummaryTemplate',
          'tr-indicator-types': '', // todo - do we need this?
          'tr-indicator-type-ab': '', // todo - do we need this?
          'tr-global-at-a-glance': 'GlobalAtAGlanceTemplate',
        },
        pdfHover: false,
        xlsHover: false,
        updatedReport: {
          id: null,
          title: null,
          short_description: null,
          image: null,
          publish_date: null,
          slug: null,
          phase: null,
          parent_group: null,
          parent_slug: null,
          favorite: false,
          notifications: false,
          template_name: null,
          trendreport_id: null,
          description: null,
          vimeo_id: null,
          sub_name: null,
          summary: null,
        },
      };
    },
    setup() {
      const aagStore = useAAGStore();
      return { aagStore };
    },
    async created() {
      await this.aagStore.getAAGDashboard();
    },
    mounted() {
      if (this.sanitized_report) this.updatedReport = this.sanitized_report;
      this.getReports();
    },
    computed: {
      currentHtmlComponent: function () {
        if (this.report.cwa_data) {
          return this.tr_cwa_mapping[this.template.slug];
        }
        return this.template.vue_component;
      },
      hasNotifications() {
        if (!this.sanitized_report) return false;
        return this.sanitized_report.notifications;
      },
      isFavorite() {
        if (!this.sanitized_report) return false;
        return this.sanitized_report.favorite;
      },
      getSelectionBarClass() {
        if (this.from_tr) {
          return 'file-selection-bar_two-col';
        }
        return this.report.data_file
          ? 'file-selection-bar_three-col'
          : 'file-selection-bar_two-col';
      },
      doscodeDefinition() {
        if (!this.report.cwa_data || !this.report.cwa_data.DOSCodeDefinition) {
          return '';
        }
        const definition = this.report.cwa_data.DOSCodeDefinition.trim();
        const definitionArray = definition.split('.');
        let finalSentence = definitionArray.pop() || definitionArray.pop();
        return finalSentence || '';
      },
      showSubName() {
        return (
          (this.report.name != null || this.report.name != '') &&
          !this.template.slug.includes('at-a-glance')
        );
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      //Inital get reports
      getReports: function () {
        var _this = this;
        axios
          .get('/reports/' + this.report_to_view)
          .then((success) => {
            _this.reports = success.data.data.reports;
            const selectedReport = this.preselected_tr_id
              ? this.reports.find(
                  (report) => report.trendsreport_id == this.preselected_tr_id
                ) || success.data.data.reports[0]
              : success.data.data.reports[0];
            _this.selectReport(selectedReport.id);
            this.image = success.data.data.reportType.image;
            this.isInsiderProduct = success.data.data.reportType.insider_group
              ? true
              : false;
            this.carouselReports = success.data.data.reports;
            this.loading = false;
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      selectReport: function (id) {
        axios
          .get('/reports/by_id/' + id, {})
          .then((success) => {
            this.report = {
              name: success.data.data.pdf_file_name,
              data_file: success.data.data.data_attachment,
              json_content: success.data.data.xml_content_json,
              imagespath: success.data.data.images_path,
              issue: success.data.data.issue,
              downloads: {
                doc: success.data.data.doc_attachment,
                xls: success.data.data.xls_attachment,
                pdf: success.data.data.pdf_attachment,
              },
              iframe: '',
              update_date: success.data.data.published_date
                ? moment(success.data.data.published_date).format(
                    'MMMM DD, YYYY'
                  )
                : success.data.data.issue
                  ? moment(success.data.data.issue).format('MMMM DD, YYYY')
                  : moment(success.data.data.updated_at).format(
                      'MMMM DD, YYYY'
                    ),
              cwa_data: success.data.data.cwa_data ?? null,
            };
            this.updatedReport.vimeo_id = success.data.data.vimeo_id;
            this.updatedReport.sub_name = success.data.data.name;
            this.updatedReport.publish_date = success.data.data.published_date;
            this.updatedReport.summary = success.data.data.summary;

            this.selected = id;
            if (this.report.json_content != null) {
              if (this.report.json_content != '') {
                this.view_type = 'html';
              } else {
                this.view_type = 'pdf';
              }
            } else {
              this.view_type = 'pdf';
            }
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      //switch between pdf and html
      changeView: function (type) {
        if (type !== this.view_type) {
          this.view_type = type;
        }
      },
      handleReportSelected(report) {
        this.selectReport(report.id);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      toggleFavorite() {
        if (!this.sanitized_report) return;
        this.$emit('toggle-favorite', this.sanitized_report);
      },
      toggleNotification() {
        if (!this.sanitized_report) return;
        this.$emit('toggle-alert', this.sanitized_report);
      },
      buildPdf() {
        if (this.report.cwa_data) {
          event.preventDefault();
          axios({
            url: `/trendsreport/tr-pdf/${this.selected}`,
            method: 'GET',
            responseType: 'blob', // Indicate that the response data should be treated as a Blob
          })
            .then((response) => {
              const date = new Date(this.report.update_date);
              const year = date.getFullYear();
              const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1
              const day = date.getDate().toString().padStart(2, '0');
              const formattedDate = `${year}-${month}-${day}`;

              const fileName = `${this.filename} - ${formattedDate}.pdf`;

              const blob = new Blob([response.data], {
                type: 'application/pdf',
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              // TODO: HANDLE ERROR - This is just silencing the error
            });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .insider-product-page {
    &__carousel-title {
      margin-top: 2em;
    }
    h2 {
      margin-bottom: 1em;
    }
  }
  .tr-report-component {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    @media screen and (min-width: 800px) {
      width: 300px;
    }
    &__icon {
      width: 100%;
      border-left: 2px solid var(--itr-grey);
      text-align: center;
      color: var(--itr-grey-mid);
      height: 100%;
      cursor: pointer;
      &:hover {
        background: var(--itr-grey-mid);
        transition: all 150ms ease;
        .icon-notification,
        .icon-star {
          color: var(--itr-white);
        }
      }
    }
    &__icon.active {
      background: var(--itr-green-mid);
    }
    &__icon:first-child {
      border-left: 0;
      @media screen and (min-width: 800px) {
        border-left: 2px solid var(--itr-grey);
      }
    }
    &__icon-old {
      width: 100%;
      border-left: 2px solid var(--itr-grey);
      text-align: center;
      color: var(--itr-grey-mid);
      height: 100%;
    }
    &__tooltip {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-notification,
      .icon-star {
        color: var(--itr-grey-mid);
        font-size: 20px;
      }
      .icon-notification.active,
      .icon-star.active {
        color: var(--itr-white);
      }

      &--tr-info {
        height: auto;
        width: auto;
        justify-content: flex-end;
      }
    }
    @media screen and (min-width: 800px) {
      width: 300px;
    }
  }

  .tr-custom-col-l {
    padding: 0 0 0 15px;
    max-width: 60%;
  }
  .tr-custom-col-r {
    padding: 0 15px 0 0;
  }
</style>
